import { ACADEMY_QUICKSTART_NAV_ITEMS } from '@common/core/config/academyQuickStartNavItems'

import type { TutorialSection } from '../types'

export const DEFAULT_QUICKSTART_SECTIONS: TutorialSection[] = ACADEMY_QUICKSTART_NAV_ITEMS.map(
  ({ title, path, order }) => ({ title, path, order })
)

export const HIDDEN_MOBILE_SECTION_PATHS = new Set(['quick-start-guide'])
